export const COMPILE_SUCCESS_MESSAGE =
  'Compilation process completed successfully';

export const tooltipContentValues = {
  EVENT_HANDLERS: 'EVENT_HANDLERS',
  EVENT_GROUP: 'EVENT_GROUP',
  SELECT_EVENT: 'SELECT_EVENT',
  CODE_SNIPPET: 'CODE_SNIPPET',
  EVENT_PAYLOAD: 'EVENT_PAYLOAD',
  VALIDATE_FIRST: 'VALIDATE_FIRST',
  APPLICATION_LOGS: 'APPLICATION_LOGS',
  EVENT_SIMULATION: 'EVENT_SIMULATION',
  EVENT_SIMULATION_LOGS: 'EVENT_SIMULATION_LOGS',
  IPARAMS: 'IPARAMS',
  OAUTH: 'OAUTH',
  PUBLISH_APP: 'PUBLISH_APP'
};

export const developedAppTypes = {
  SAME_VERSION: 'SAME_VERSION',
  NEW_APP: 'NEW_APP'
};

export const dashboardFields = {
  IPARAMS: 'IPARAMS',
  SETTINGS: 'SETTINGS'
};

export const customSelectStyles = {
  '.twigs-select__control, .twigs-select__menu': {
    background: '$white200 !important',
    color: '$white900 !important',
    border: '$borderWidths$xs solid $black300 !important',
    boxShadow: 'none !important',
    '&:focus, &:hover, &:active': {
      background: '$white200 !important',
      color: '$white900 !important'
    }
  },
  '.twigs-select__single-value': {
    color: '$white900 !important'
  },
  '.twigs-select__option, .twigs-select__option--is-selected': {
    color: '$white900 !important',
    background: '#2d2d2d !important',
    zIndex: 10
  },
  '.twigs-select__option.twigs-select__option--is-focused': {
    background: '$black800 !important'
  }
};

export const iparamsDefaultValues = {
  displayName: '',
  keyName: '',
  type: '',
  description: '',
  secure: '',
  required: '',
  product: '',
  skipApi: {}
};

export const iparamsOptions = [
  { label: 'Email', value: 'email' },
  { label: 'Phone Number', value: 'phone_number' },
  { label: 'API Key', value: 'api_key' },
  { label: 'URL', value: 'url' },
  { label: 'Text', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Date', value: 'date' },
  { label: 'Radio', value: 'radio' }
];

export const booleanOptions = [
  { label: 'True', value: true },
  { label: 'False', value: false }
];

export const productOptions = [
  { label: 'SurveySparrow', value: 'SurveySparrow', domain: 'surveysparrow' },
  { label: 'ThriveSparrow', value: 'ThriveSparrow', domain: 'thrivesparrow' }
];

export const keyboardKeyConstants = {
  ENTER: 'Enter',
  INPUT: 'INPUT'
};


export const sidebarItems = {
  CONFIGURATION: 'CONFIGURATION',
  EVENT_HANDLER: 'EVENT_HANDLER'
};
